import { render, staticRenderFns } from "./PendingExplanations.vue?vue&type=template&id=06babd62&scoped=true"
import script from "./PendingExplanations.vue?vue&type=script&lang=js"
export * from "./PendingExplanations.vue?vue&type=script&lang=js"
import style0 from "./PendingExplanations.vue?vue&type=style&index=0&id=06babd62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06babd62",
  null
  
)

export default component.exports